<template>
  <div class="not-found">
    <div class="not-found__message text-xs-center">
      <h1>
        <span class="primary--text">Acción </span>no <span class="primary--text">permitida</span>
      </h1>
      <h4>USTED NO CUENTA CON LOS ROLES NECESARIOS PARA REALIZAR ESTA ACCION: </h4>
      <h4>USUARIO: {{ $storage.get("user").usuario }}</h4>
      <v-btn color="primary" round  @click="back()"><v-icon dark>arrow_back</v-icon> Volver atrás</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    back () {
      this.$router.push("/");
      // if (this.$store.state.state403) {
      //   this.$store.state.state403 = false;
      //   this.$store.state.modal = false;
      //   this.$router.go(-2);
      // } else {
      //   this.$router.go(-1);
      // }
    }
  }
};
</script>

<style src="./pages.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/common/layout/pages/SinPermiso.vue